import Header from './modules/header.js';
import Timeline from './modules/timeline.js';
import { Commerce } from './modules/commerce.js';

const timelineInstances = new WeakMap();
let headerInstance = null;

Drupal.behaviors.noahsProFrontend = {
  attach(context) {
    const roots = [];
    if (context instanceof Element && context.matches('.timeline-container')) roots.push(context);
    roots.push(...context.querySelectorAll?.('.timeline-container') || []);

    roots.forEach((root) => {
      if (!timelineInstances.has(root)) timelineInstances.set(root, new Timeline(root));
    });

    if (context === document && !document.documentElement.dataset.noahsProHeader) {
      document.documentElement.dataset.noahsProHeader = 'true';
      headerInstance = new Header();
    }
  },
  detach(context, settings, trigger) {
    if (trigger !== 'unload') return;
    const roots = [];
    if (context instanceof Element && context.matches('.timeline-container')) roots.push(context);
    roots.push(...context.querySelectorAll?.('.timeline-container') || []);
    roots.forEach((root) => {
      timelineInstances.get(root)?.destroy();
      timelineInstances.delete(root);
    });

    if (context === document) {
      headerInstance?.destroy();
      headerInstance = null;
      delete document.documentElement.dataset.noahsProHeader;
    }
  }
};

Commerce();
